import Abhinav from '../../Assets/teams-assets/Abhinav Chakravarty.jpg';
import Agrata from '../../Assets/teams-assets/Agrata Dwivedi.jpg';
import Anishaa from '../../Assets/teams-assets/Anishaa Choudhury.jpg';
import Divyanshu from '../../Assets/teams-assets/Divyanshu Tiwari.jpg';
import Jatin from '../../Assets/teams-assets/Jatin Kumar.jpg';
import Muskan from '../../Assets/teams-assets/Muskan Bansal.jpg';
import Naman from '../../Assets/teams-assets/Naman Jain.png';
import Ritvik from '../../Assets/teams-assets/Ritvik Sharma.jpg';
import Samarth from '../../Assets/teams-assets/Samarth Tandon.jpg';
import Shivam from '../../Assets/teams-assets/Shivam Saxena.jpg';
import Shreyash from '../../Assets/teams-assets/Shreyash Pant.jpg';
import Simran from '../../Assets/teams-assets/Simran Kathuria.jpg';
import Utkarsh from '../../Assets/teams-assets/UtkarshYadav.jpg';
import Vanshaj from '../../Assets/teams-assets/Vanshaj Johri.jpg';
import Vinayak from '../../Assets/teams-assets/Vinayak Raj.jpg';

const teamDetail = [
    {
        id: 1,
        name: "Dr.Veena Khandelwal",
        imageURL: Utkarsh,
        designation: "Faculty Advisor"
    },
    {
        id: 2,
        name: "Ms.Anitha RajaKumari",
        imageURL: Utkarsh,
        designation: "Faculty Advisor"
    },
    {
        id: 3,
        name: "Utkarsh Yadav",
        imageURL: Utkarsh,
        designation: "Technical Head"
    },
    {
        id: 4,
        name: "Ritvik Sharma",
        imageURL: Ritvik,
        designation: "Web Developer"
    },
    {
        id: 5,
        name: "Vinayak Raj",
        imageURL: Vinayak,
        designation: "Web Developer"
    },
    {
        id: 6,
        name: "Divyanshu Tiwari",
        imageURL: Divyanshu,
        designation: "Executive"
    },
    {
        id: 7,
        name: "Abhinav Chakravarty",
        imageURL: Abhinav,
        designation: "Co-Executive"
    },
    {
        id: 8,
        name: "Shivam Saxsena",
        imageURL: Shivam,
        designation: "Public Relation"
    },
    {
        id: 9,
        name: "Jatin Arora",
        imageURL: Jatin,
        designation: "Public Relation"
    },
    {
        id: 10,
        name: "Muskan Bansal",
        imageURL: Muskan,
        designation: "Creative Head"
    },
    {
        id: 11,
        name: "Anishaa Choudhary",
        imageURL: Anishaa,
        designation: "Treasurer"
    },
    {
        id: 12,
        name: "Naman Jain",
        imageURL: Naman,
        designation: "Management Head"
    },
    {
        id: 13,
        name: "Simran Kathuria",
        imageURL: Simran,
        designation: "Creative Head"
    },
    {
        id: 14,
        name: "Samarth Tondon",
        imageURL: Samarth,
        designation: "Publicity"
    },
    {
        id: 15,
        name: "Shreyash Pant",
        imageURL: Shreyash,
        designation: "Creative Head"
    },
    {
        id: 16,
        name: "Vanshaj Johri",
        imageURL: Vanshaj,
        designation: "Management"
    },
    {
        id: 17,
        name: "Agrata Dwivedi",
        imageURL: Agrata,
        designation: "Publicity"
    },
];

export default teamDetail;